import { useFeatureGate } from '@statsig/expo-bindings';
import { Redirect } from 'expo-router';

import IncomeSplitOverview from '../../../banking/components/income-split/overview/IncomeSplitOverview';
import { FeatureFlags } from '../../../feature-flags/FeatureFlags';

export default function IncomeSplitOverviewScreen() {
    const { value: enableIncomeSplitVisuals } = useFeatureGate(
        FeatureFlags.ENABLE_INCOME_SPLIT_VISUALS,
    );

    if (!enableIncomeSplitVisuals) {
        return <Redirect href="/" />;
    }

    return <IncomeSplitOverview />;
}
